export const isPipSupported = 'documentPictureInPicture' in window;
